const CardGetter = {
  cards: (state) => state.cards
};

export default CardGetter;
